import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
  withCampaignSiteMap,
  siteMapPropType,
  processor,
} from '@bingads-webui-campaign-react/with-site-map';
import { useCurrentCampaign, useCurrentAdGroup } from '@bingads-webui-campaign-react/use-current-scope-entity';
import { withLayoutContext } from '@bingads-webui-react/app-layout-container';


const isExperimentCampaign = (campaign, adGroup) => !!(campaign && campaign.ExperimentId > 0 && !adGroup);
const ExperimentSubPageMenu = React.lazy(() => import(/* webpackMode: 'eager' */ './experiment-sub-page-menu').then(({ StyledExperimentSubPageMenu }) => ({ default: StyledExperimentSubPageMenu })));

export const Loader = (props) => {
  const { siteMap, updateAvailability, layoutConfig } = props;
  const campaign = useCurrentCampaign();
  const adGroup = useCurrentAdGroup();

  const selectedParent = _.findWhere(siteMap, { selected: true });
  // add judgement to fix the experiment part is blank when the score card hidden.
  const showCard = layoutConfig.tab.mode && layoutConfig.tab.mode === 'hidden';
  const available = isExperimentCampaign(campaign, adGroup) && !_.isEmpty(selectedParent) && !showCard;
  useEffect(() => {
    updateAvailability(available);
  });

  return props.isVisible ? (
    <React.Suspense fallback={null}>
      <ExperimentSubPageMenu {...props} available={available} experimentId={campaign ? campaign.ExperimentId : null} />
    </React.Suspense>
  ) : null;
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  isVisible: PropTypes.bool.isRequired,
  updateAvailability: PropTypes.func,
  layoutConfig: PropTypes.shape({
    header: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    menu: PropTypes.object.isRequired,
    status: PropTypes.object.isRequired,
    tab: PropTypes.object.isRequired,
    subTab: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired,
  }).isRequired,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
};

export const ExperimentSubPageMenuLoader = withLayoutContext(withCampaignSiteMap(
  React.memo(Loader),
  [processor.processPermissions, processor.processPath]
));
